__webpack_require__.p = "https://oaas.eu.platform.xweather.com/";